import styled from '@emotion/styled'
import CommonModal from '@/components/common/Modal'
import { Body } from '../../../PolicyDetailPage/BillingInformation/styles'
import { Form, Input as FormInput, InputNumber } from 'antd'

export const Modal = styled(CommonModal)<any>`
  .ant-modal-title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.004em;
    color: #000000;
    height: 50%;
  }

  .ant-btn-default {
    box-shadow: none;
    height: auto;
    padding: 10px 16px;
    border-radius: 8px;
  }

  .ant-btn-primary {
    box-shadow: none;
    height: auto;
    padding: 10px 16px;
    border-radius: 8px;
  }

  .ant-modal-header {
    padding: 24px;
    margin-bottom: -1px;
  }

  .ant-modal-body {
    padding: 0px !important;
  }

  .ant-modal-content {
    padding: 0px;
  }
`

export const FormItem = styled(Form.Item)`
  margin-bottom: 16px;

  label {
    font-family: 'Prompt';
    font-style: normal;
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #000000;
  }

  .ant-form-item-label {
    margin: 0;
    padding: 0 0 4px;
    white-space: initial;
    text-align: start;
  }

  .ant-form-item-explain {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.004em;
    color: #666666;
    margin-top: 4px;
    margin-bottom: 16px;
  }
`

export const Input = styled(FormInput)`
  font-family: 'Prompt';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 16px;
  border-radius: 8px;
`

export const BodyStyled = styled(Body)`
  display: grid;
  padding: 20px 24px 0px 24px;
  grid-gap: 16px;
`

export const Label = styled.span`
  color: black;
  font-size: 14px;
  font-family: Prompt;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
`

export const RequestWrapper = styled.span`
  color: #ef2605;
  font-size: 14px;
  font-family: Prompt;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
`

export const AmountWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 24px 1fr;
  grid-gap: 16px;
  align-items: center;
`

export const IconSvg = styled('img')`
  width: 20px;
  height: 20px;
`

export const InputNumberStyled = styled(InputNumber)`
  height: 44px;
  width: 100%;
  font-family: 'Prompt';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  border-radius: 8px;
  place-content: center;
`
